import { fr } from './translations/fr';
import { pt } from './translations/pt';
import { de } from './translations/de';
import { it } from './translations/it';
import { zh } from './translations/zh';

export const extraTranslations = { fr, pt, de, it, zh };
